import React from 'react';

const Link = () => (
  <svg width="9" height="9">
    <path
      fill="#6A6D70"
      fillRule="evenodd"
      d="M4.569 6.3096l1.3917 1.3916c.199.199.512.1967.7066.0022l1.036-1.036c.1917-.1917.1937-.511-.002-.7067L6.3095 4.569l.5802-.5802 1.6785 1.6786c.3872.3872.3907 1.0115-.001 1.4033L7.0706 8.5672c-.3878.3878-1.0133.391-1.4033.001L3.9888 6.89l.5802-.5802zM4.7004 2.96L3.3088 1.568c-.199-.199-.512-.1967-.7067-.0022L1.566 2.602c-.1916.1917-.1935.511.0022.7068L2.96 4.7004l-.5803.5802L.701 3.602C.314 3.215.3106 2.5906.7023 2.1988L2.1987.7022C2.5865.3144 3.212.3112 3.602.7012l1.6786 1.6785-.5802.5802zm-1.5162.2242c.1878-.1877.496-.184.6842.0043L6.081 5.401c.19.1902.1865.502.0042.6842-.1878.1877-.496.184-.684-.0042L3.1884 3.8684c-.19-.19-.1865-.502-.0043-.6842z"
    />
  </svg>
);

export default Link;
